module.exports = __webpack_public_path__ + "static/progetto_valtellinapalace8_giorno-d9c79d3872a208283d54bf82745827bd.jpg";